import { render, staticRenderFns } from "./ArchiveUploadWrapper.vue?vue&type=template&id=121eca74&scoped=true"
import script from "./ArchiveUploadWrapper.vue?vue&type=script&lang=js"
export * from "./ArchiveUploadWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121eca74",
  null
  
)

export default component.exports